/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';
import common from '../_common/common_attendance';

const datasetParams = {
  mainFile: 'Attendance/Outputs/s_data/Attendance_s_data_justPY.csv',
  runDetailsFile: 'Attendance/Outputs/s_data/Attendance_s_data_justPY_runDetails.csv',
  tableName: 'Attendance_s',
  mainDateField: 'Date',
  headersRemaps: {
    AdmissionRevenue: 'AdmissionRevenues',
    Budget_Attendance: 'BudgetAttendance',
    Budget_Admission_Revenue: 'BudgetAdmissionRevenues',
    Category: 'ProductType',
    Weather_Code: 'WeatherCode',
  },
  calculatedMetrics: common.attendance_calculatedMetrics,
  metrics: common.attendance_metrics,
  valuesRemaps: {
    ProductType: {
      'MDT/MPT': 'MDT',
    },
  },
  transformRow: (row) => ({
    ...row,
    Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
    ProductCategory: ['SDT', 'MDT'].includes(row.ProductType) ? 'Discrete' : ['FC', 'Fun Card', 'Pass'].includes(row.ProductType) ? 'Pass' : 'Free',
  }),
  filterDimensions: {
    ...common.attendance_filterDimensions,
  },
};

export default datasetParams;
